'use client'

import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { type FloatingTriggerType } from '@/defs/floating'

import { FloatingTooltipDesktop } from './FloatingTooltipDesktop/FloatingTooltipDesktop'

export const FloatingTooltip = (props: FloatingTriggerType) => {
  const { isDesktop } = useBreakpoints()

  return !props.content || !isDesktop ? props.children : <FloatingTooltipDesktop {...props} />
}
